import { SortState } from "./";
import { Config } from "../../context";
import { getColumnValue } from "../../util";
// @ts-ignore
import fastsort from "fast-sort/sort.es5";

function sortData(data: any[], state: SortState, configs: Config[], t: any) {
  const { sortKey, sortDirection } = state;

  // find column-config of selected column
  const config = configs.find(x => x.key === sortKey)!;

  if (!sortKey) {
    return data;
  }

  const withSortValue = data.map(entry => ({
    ...entry,
    __sortValue: getColumnValue(entry, config, t)
  }));

  return fastsort(withSortValue)[sortDirection]("__sortValue");
}

export default sortData;
